export default [
  "strange",
  "brittle",
  "obsidian",
  "pained",
  "alert",
  "drowsy",
  "electrified",
  "galvanized",
  "gorgeous",
  "beautiful",
  "disconcerting",
];
